class BanzrcDtReady extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-dt-ready-config]')];
    this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button.dataset.dtReadyConfig)));
    this.mobile = window.matchMedia('(max-width: 749px)');
    this.syncDetails = () => this.querySelectorAll('details').forEach((layer) => {
      layer.open = !this.mobile.matches || layer.dataset.mobileOpen === 'true';
      const summary = layer.querySelector('summary');
      if (summary) summary.tabIndex = this.mobile.matches ? 0 : -1;
    });
    this.syncDetails();
    this.mobile.addEventListener('change', this.syncDetails);
  }

  select(config) {
    this.buttons.forEach((button) => {
      const active = button.dataset.dtReadyConfig === config;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    this.querySelectorAll('[data-dt-ready-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.dtReadyPanel !== config;
    });
    this.querySelectorAll('[data-dt-ready-label]').forEach((label) => { label.textContent = config.toUpperCase(); });
  }

  disconnectedCallback() {
    this.mobile?.removeEventListener('change', this.syncDetails);
  }
}

if (!customElements.get('banzrc-dt-ready')) customElements.define('banzrc-dt-ready', BanzrcDtReady);
